import {_PromotionsWithGeolocation as PromotionsWithGeolocation} from "./_PromotionsWithGeolocation";
import {_PromotionsNoGeolocation as PromotionsNoGeolocation} from "./_PromotionsNoGeolocation";
import {_PromotionsBirthday as PromotionsBirthday} from "./_PromotionsBirthday";

export const PromotionsAPI = {
    PromotionsWithGeolocation: PromotionsWithGeolocation,
    PromotionsNoGeolocation: PromotionsNoGeolocation,
    PromotionsBirthday: PromotionsBirthday
};